// src/Pages/AdminLogin.js
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Heading,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAdmin } from "../../context/AdminContext";
import {trackClick} from '../../ga'
export default function AdminLogin() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

const { login } = useAdmin();

const onSubmit = async (data) => {
  try {
    const response = await axios.post("https://itracks-api-prod-22dc11310f73.herokuapp.com/api/auth/login", data);
    const token = response.data.token;

    login(token); 
    setTimeout(() => {
      navigate("/admin/messages");
    }, 100); 

    toast({
      title: "Login successful",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  } catch (error) {
    toast({
      title: "Invalid credentials",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};



  return (
    <Box py={20} px={4} bgGradient="linear(to-b, #ffffff, #2f4280)" minH="100vh"  onClick={() => trackClick(`Clicked Login page`)}>
      <Box maxW="md" mx="auto" bg="white" p={10} rounded="xl" boxShadow="2xl">
        <Heading mb={6} textAlign="center" color="#2f4280">
            {i18n.language === "ar" ? "تسجيل الدخول" : "Login"}
            </Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={5}>
            <FormControl isInvalid={errors.username}>
              <FormLabel>
                    {i18n.language === "ar" ? "اسم المستخدم" : "Username"}
                </FormLabel>
              <Input {...register("username", { required: "Required" })} 
              placeholder={i18n.language === "ar" ? "اسم المستخدم" : "Username"}
              
              />
              {errors.username && <Text color="red.500">{errors.username.message}</Text>}
            </FormControl>

            <FormControl isInvalid={errors.password}>
              <FormLabel>
                
                            {i18n.language === "ar" ? " كلمة المرور" : "Password"}
                </FormLabel>
              <Input type="password" {...register("password", { required: "Required" })} placeholder="••••••••" />
              {errors.password && <Text color="red.500">{errors.password.message}</Text>}
            </FormControl>

            <Button type="submit" colorScheme="orange" w="full">
                    {i18n.language === "ar" ? "تسجيل الدخول" : "Login"}
                </Button>
          </VStack>
        </form>
      </Box>
    </Box>
  );
}
